import React from "react";
import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";
import { Logo } from "../../../components/logo/Logo";
import SolutionsDropdown from "./solutions/SolutionsDropdown";
import ProductsDropdown from "./products/ProductsDropdown";
import { ChevronDown } from "lucide-react";

const Header = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePricingClick = (e) => {
    e.preventDefault();
    navigate('/pricing');
  };

  const handleTeamClick = (e) => {
    e.preventDefault();
    if (window.location.pathname === '/') {
      scrollToSection('team');
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('team');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleLogoClick = () => {
    // Check if we're on the landing page
    if (window.location.pathname === '/') {
      // Scroll to top smoothly
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Navigate to landing page and scroll to top
      navigate('/');
      // Use setTimeout to ensure navigation completes before scrolling
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <header className={ styles.header }>
      <div onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <Logo className={ styles.logo } />
      </div>
      <nav>
        <ul className={ styles.navList }>
          <li className={ `${styles.hasDropdown} has-dropdown` }>
            <span className={ styles.navLink }>
              Product <ChevronDown size={ 14 } className={ styles.chevron } />
            </span>
            <ProductsDropdown />
          </li>
          <li className={ `${styles.hasDropdown} has-dropdown` }>
            <span className={ styles.navLink }>
              Solutions <ChevronDown size={ 14 } className={ styles.chevron } />
            </span>
            <SolutionsDropdown />
          </li>
          <li>
            <a href="/pricing" onClick={handlePricingClick}>Pricing</a>
          </li>
          <li>
            <a href="#team" onClick={handleTeamClick}>Team</a>
          </li>
        </ul>
      </nav>
      <div className={ styles.headerButtons }>
        <button onClick={ () => navigate('/login') } className={ styles.loginButton }>
          Login
        </button>
        <button onClick={ () => navigate('/contact') } className={ styles.contactButton }>
          Contact Us
        </button>
      </div>
    </header>
  );
};

export default Header;